module.exports = __webpack_public_path__ + "static/media/analytics.fee4ef2b.svg";